import DepositFaq from "@/components/layout/deposit-faq";
import IconFont from "@/components/ui/iconFont";
import { useTranslations } from "next-intl";
import { useEffect, useMemo, useRef, useState } from "react";

interface DelayTipsProps {
  time?: number;
  type?: string;
}

export default function DelayTips(props: DelayTipsProps) {
  const t = useTranslations('personal');
  const [height, setHeight] = useState(0);
  const faqRef = useRef(null);

  const delayTips = useMemo(() => {
    if (props.time === 0) {
      return '';
    }
    const texts: Record<number, string> = {
      10: t('orderDelay.slightNotice'),
      30: t('orderDelay.expediting'),
      60: t('orderDelay.abnormalHeavy')
    };
    let text = '';
    const time = Number(props.time || 0);

    const elapsedMinutes = (Date.now() / 1000 - time) / 60;

    if (elapsedMinutes > 60) {
      text = texts[60];
    } else if (elapsedMinutes >= 30) {
      text = texts[30];
    } else if (elapsedMinutes >= 10) {
      text = texts[10];
    }
    console.log(elapsedMinutes);
    return text;
  }, [props.time, t]);

  useEffect(() => {
    if (faqRef.current) {
      setHeight((faqRef.current as HTMLDivElement).offsetHeight + 30);
    }
  }, [props.time]);

  return (
    <>
      <div className="w-full" style={{
        height: `${height}px`
      }} />
      <div className='fixed left-0 right-0 bottom-0 px-[27px] pb-[30px] z-20 bg-[#101219]' ref={faqRef}>
        {!!props.time && delayTips && (<div className='py-[10px] flex justify-center leading-[15px] text-[11px] text-[#A9B5CB]'>
          <IconFont name="tips" size={13} className="mr-[5px] mt-[2px]" />
          <span>{delayTips}</span>
        </div>)}
        <DepositFaq type={props.type} onlyShowTitle={true} />
      </div>
    </>
  );
}